// extracted by mini-css-extract-plugin
export default {"norequestmodal":"ErrorPage_norequestmodal__xifc+","errdescription":"ErrorPage_errdescription__QLSzT","errimg":"ErrorPage_errimg__-i2fP"};